<div class="login-container">
  <!-- Header -->
  <header class="login-header">
    <div class="navbar-inner">
      <div class="logo">
        <h1>⚽ Sportowcy</h1>
      </div>
    </div>
  </header>

  <!-- Main Section -->
  <main class="login-main">
    <div class="login-wrapper">
      <!-- Welcome Section -->
      <div class="login-card">
        <!-- Logo / Club Info -->
        <div class="login-icon">👤</div>

        <!-- Title -->
        <h1>Zaloguj się</h1>
        <p class="login-subtitle">Wpisz swój email, aby otrzymać link logowania</p>

        <!-- Error Alert -->
        @if (error) {
          <div class="alert alert-error">
            <span class="alert-text">{{ error | translate }}</span>
          </div>
        }

        <!-- Success Alert -->
        @if (successMessage) {
          <div class="alert alert-success">
            <span class="alert-text">{{ successMessage | translate }}</span>
          </div>
        }

        <!-- Dev Magic Link (DEBUG only) -->
        @if (devMagicLink) {
          <div class="alert alert-info">
            <div class="dev-link">
              <span class="alert-text">Link dev:</span>
              <a [href]="devMagicLink" target="_self" rel="noopener">{{ devMagicLink }}</a>
            </div>
            @if (devNote) {
              <p class="dev-note">{{ devNote }}</p>
            }
          </div>
        }

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <!-- Email Input -->
          <div class="form-group">
            <label for="email" class="form-label">Email</label>
            <input
              type="email"
              id="email"
              class="form-input"
              placeholder="twoj@email.com"
              formControlName="email"
              required
              />
            @if (email?.invalid && email?.touched) {
              <div class="form-error">
                @if (email?.errors?.['required']) {
                  <span>Email jest wymagany</span>
                }
                @if (email?.errors?.['email']) {
                  <span>Wpisz prawidłowy email</span>
                }
              </div>
            }
          </div>

          <!-- Tenant Selection (Optional) -->
          @if (showTenantSelect) {
            <div class="form-group">
              <label for="tenant" class="form-label">Klub/Organizacja</label>
              <select
                id="tenant"
                class="form-input"
                formControlName="tenant"
                >
                <option value="">-- Wybierz klub --</option>
                @for (tenant of availableTenants; track tenant) {
                  <option [value]="tenant.schema_name">
                    {{ tenant.name }}
                  </option>
                }
              </select>
              @if (tenant?.invalid && tenant?.touched) {
                <div class="form-error">
                  @if (tenant?.errors?.['required']) {
                    <span>Wybór klubu jest wymagany</span>
                  }
                </div>
              }
            </div>
          }

          <!-- Submit Button -->
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            [disabled]="isLoading || loginForm.invalid"
            >
            @if (!isLoading) {
              <span>Wyślij link logowania</span>
            }
            @if (isLoading) {
              <span>
                <span class="spinner"></span>
                Wysyłanie...
              </span>
            }
          </button>
        </form>

        <!-- Info Section -->
        <div class="login-info">
          <p class="info-text">
            Na podany email wyślemy bezpieczny link do zalogowania się.
            Link będzie ważny przez 24 godziny.
          </p>
        </div>

        <!-- Privacy Notice -->
        <div class="privacy-notice">
          <p>
            Logując się akceptujesz nasze
            <a href="/privacy" target="_blank">Politykę Prywatności</a>
            i
            <a href="/terms" target="_blank">Warunki Użytkowania</a>
          </p>
        </div>
      </div>

      <!-- Side Panel (Desktop) -->
      @if (!isMobile) {
        <aside class="login-side">
          <div class="side-content">
            <h2>Zarządzaj swoim klubem</h2>
            <ul class="side-list">
              <li>✅ Zawodnicy i treningi</li>
              <li>💰 Finanse klubu</li>
              <li>📊 Raporty i statystyki</li>
              <li>💬 Komunikacja z drużyną</li>
              <li>🔐 Bezpieczeństwo danych</li>
            </ul>
            <p class="side-footer">
              Dołącz do setek klubów korzystających z Sportowcy
            </p>
          </div>
        </aside>
      }
    </div>
  </main>

  <!-- Footer -->
  <footer class="footer">
    <div class="footer-content">
      <p>{{ 'pages.landing.footer.copyright' | translate }}</p>
      <p class="footer-version">{{ 'common.app_version' | translate: { version: appVersion } }}</p>
    </div>
  </footer>
</div>
